import {GLOBAL} from "../../../common/globals";
import {HeroTeaserImageReadyHandler} from "./HeroTeaserImageReadyHandler";

const AVERAGE_WORDS_PER_MINUTE = 200;

export class EopArticleHeroTeaser extends HTMLElement {

    public connectedCallback(): void {
        const readingTimeElement = this.querySelector(".reading-time")!;
        readingTimeElement.textContent = this.determineReadingTime();
        this.querySelector<HTMLElement>(".article-hero-teaser-bottom")!.style.visibility = "visible";

        new HeroTeaserImageReadyHandler(".article-hero-teaser-image").installOn(this);
    }

    private determineReadingTime(): string {
        const text = GLOBAL.bodyElement().querySelector("main")?.innerText?.trim() ?? "";
        const numberOfWords = text.split(/\s+/).length;
        return Math.ceil(numberOfWords / AVERAGE_WORDS_PER_MINUTE) + " min";
    }
}

customElements.define("eop-article-hero-teaser", EopArticleHeroTeaser);